import { render, staticRenderFns } from "./OtherMain.vue?vue&type=template&id=48dc64ae"
import script from "./OtherMain.vue?vue&type=script&lang=js"
export * from "./OtherMain.vue?vue&type=script&lang=js"
import style0 from "./OtherMain.vue?vue&type=style&index=0&id=48dc64ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports